module.exports = __webpack_public_path__ + "img/3.2fa3bf50.jpg";